import { z } from "zod";
import { Id } from "../base";
import { AssignableCommunityRoleSchema } from "./role";
import { communityRoleValues, userInviteStatusValues, userInviteMethodValues, } from "../constant_values";
import { UserStatusSchema } from "../user/index";
import { TimestampInputSchema } from "../epoch";
//#region SCHEMA
//#region INVITE & MEMBERSHIP
export const InviteStatusSchema = z.enum(userInviteStatusValues);
export const InviteMethodSchema = z.enum(userInviteMethodValues);
export const InviteSchema = z.object({
    communityId: Id,
    role: AssignableCommunityRoleSchema,
});
export const InviteByLinkSchema = InviteSchema;
export const ClaimInviteSchema = z.object({
    token: z.string().min(1, "token is required"),
});
export const CommunityMembershipSchema = z.object({
    userId: Id,
    communityId: Id,
    role: z.enum(communityRoleValues),
    status: UserStatusSchema,
    createdAt: TimestampInputSchema,
    updatedAt: TimestampInputSchema.optional(),
});
export const CommunityMembershipPatchSchema = CommunityMembershipSchema.partial().omit({
    communityId: true,
    status: true,
    createdAt: true,
    updatedAt: true,
    role: true,
}).extend({
    role: AssignableCommunityRoleSchema.optional(),
});
//#endregion INVITE & MEMBERSHIP
//#region TEAM
//#region TEAM MEMBERS
export const CommunityTeamMemberRecordSchema = z.object({
    userId: Id,
    role: z.enum(communityRoleValues),
    status: UserStatusSchema,
    createdAt: TimestampInputSchema,
    updatedAt: TimestampInputSchema.optional(),
});
export const CommunityTeamMemberPatchSchema = CommunityTeamMemberRecordSchema.partial()
    .omit({
    createdAt: true,
    updatedAt: true,
    role: true,
})
    .extend({
    role: AssignableCommunityRoleSchema.optional(),
})
    .required({
    userId: true,
});
//#endregion TEAM MEMBERS
//#endregion TYPES
